import { render, staticRenderFns } from "./MonitoringStatusTruk.vue?vue&type=template&id=22ca9ab0&scoped=true"
import script from "./MonitoringStatusTruk.vue?vue&type=script&lang=js"
export * from "./MonitoringStatusTruk.vue?vue&type=script&lang=js"
import style0 from "./MonitoringStatusTruk.vue?vue&type=style&index=0&id=22ca9ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ca9ab0",
  null
  
)

export default component.exports